import React from 'react'
import { withTranslation } from "react-i18next";

const ErrorAlert = (props) => {
  console.log("ErrorAlert :: Component => Enter");
  const { t } = props;

  return (
    <div className="alert alert-danger" role="alert">
      {t(props.error)}
    </div>
  )
};

export default withTranslation()(ErrorAlert);

